<div class="company-name-info">
  <img
    src="../../../../../assets/svg/icons/empresa preenchido.svg"
    alt="Ícone de empresa"
  />
  <p>{{ companyDescription }}</p>
</div>

<form [formGroup]="enderecoForm">
  <!-- SEÇÃO INFORMAÇÕES PRINCIPAIS -->
  <section>
    <p class="section-title">INFORMAÇÕES PRINCIPAIS</p>

    <mat-grid-list cols="4" rowHeight="100px" gutterSize="1em">
      <!-- Nome do Endereço -->
      <mat-grid-tile colspan="4">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nome do endereço</mat-label>
          <input
            matInput
            formControlName="nomeEndereco"
            placeholder=""
            required
          />
          <mat-error
            *ngIf="enderecoForm.get('nomeEndereco')?.hasError('required')"
          >
            Nome do endereço é obrigatório
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>

      <!-- CEP -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>CEP</mat-label>
          <input
            matInput
            formControlName="cep"
            placeholder="00000-000"
            mask="00000-000"
            required
          />
          <mat-error *ngIf="enderecoForm.get('cep')?.hasError('required')">
            CEP é obrigatório
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>

      <!-- Logradouro -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Logradouro</mat-label>
          <input
            matInput
            formControlName="logradouro"
            placeholder="Rua, Avenida, Praça"
            required
          />
          <mat-error
            *ngIf="enderecoForm.get('logradouro')?.hasError('required')"
          >
            Logradouro é obrigatório
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>

      <!-- Número -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Número</mat-label>
          <input
            matInput
            formControlName="numero"
            placeholder="Número"
            type="number"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Complemento -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Complemento</mat-label>
          <input
            matInput
            formControlName="complemento"
            placeholder="Complemento"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Estado -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Estado</mat-label>
          <mat-select formControlName="ufResidencia" required>
            <mat-option value="">Selecione</mat-option>
            <mat-option *ngFor="let uf of ufOptions" [value]="uf.id_uf">
              {{ uf.nome }} ({{ uf.sigla }})
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="enderecoForm.get('ufResidencia')?.hasError('required')"
          >
            Estado é obrigatório
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>

      <!-- Cidade -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Cidade</mat-label>
          <mat-select formControlName="cidadeResidencia" required>
            <mat-option value="">Selecione</mat-option>
            <mat-option
              *ngFor="let cidade of cidadeOptionsFiltradas"
              [value]="cidade.id_cidade"
            >
              {{ cidade.nome }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="enderecoForm.get('cidadeResidencia')?.hasError('required')"
          >
            Cidade é obrigatória
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </section>

  <div class="spacer" style="height: 2em"></div>

  <!-- SEÇÃO ATENDIMENTO SESI -->
  <section>
    <p class="section-title">ATENDIMENTO SESI</p>

    <mat-grid-list cols="3" rowHeight="100px" gutterSize="1em">
      <!-- Departamento Regional -->
      <mat-grid-tile colspan="1">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Departamento regional</mat-label>
          <mat-select formControlName="departamentoRegional" required>
            <mat-option value="">Selecione</mat-option>
            <mat-option
              *ngFor="let depto of departamentosRegionais"
              [value]="depto.nome"
            >
              {{ depto.nome }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="enderecoForm.get('departamentoRegional')?.hasError('required')"
          >
            Departamento regional é obrigatório
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>

      <!-- Região -->
      <mat-grid-tile colspan="1">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Região</mat-label>
          <mat-select formControlName="regiao">
            <mat-option value="">Selecione</mat-option>
            <mat-option *ngFor="let regiao of regioes" [value]="regiao.nome">
              {{ regiao.nome }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-grid-tile>

      <!-- Unidade Operacional -->
      <mat-grid-tile colspan="1">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Unidade Operacional</mat-label>
          <mat-select formControlName="unidadeOperacional" required>
            <mat-option value="">Selecione</mat-option>
            <mat-option
              *ngFor="let unidade of unidadesOperacionais"
              [value]="unidade.nome"
            >
              {{ unidade.nome }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="enderecoForm.get('unidadeOperacional')?.hasError('required')"
          >
            Unidade operacional é obrigatória
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </section>
  <div class="spacer" style="height: 2em"></div>

  <!-- SEÇÃO CONTATO DO ENDEREÇO -->
  <section>
    <p class="section-title">CONTATO DO ENDEREÇO</p>

    <mat-grid-list cols="2" rowHeight="100px" gutterSize="1em">
      <!-- Nome completo -->
      <mat-grid-tile colspan="1">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nome completo</mat-label>
          <input
            matInput
            formControlName="nomeContato"
            placeholder="Nome do contato"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- E-mail -->
      <mat-grid-tile colspan="1">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>E-mail</mat-label>
          <input
            matInput
            formControlName="emailContato"
            type="email"
            placeholder="email@exemplo.com"
            required
          />
          <mat-error
            *ngIf="enderecoForm.get('emailContato')?.hasError('required')"
          >
            E-mail é obrigatório
          </mat-error>
          <mat-error
            *ngIf="enderecoForm.get('emailContato')?.hasError('email')"
          >
            Digite um e-mail válido
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>

      <!-- Cargo -->
      <mat-grid-tile colspan="1">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Cargo</mat-label>
          <input
            matInput
            formControlName="cargoContato"
            placeholder="Cargo do contato"
          />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Telefone celular -->
      <mat-grid-tile colspan="1">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Telefone celular</mat-label>
          <input
            matInput
            formControlName="telefoneContato"
            placeholder="(00) 00000-0000"
            mask="(00) 00000-0000"
            required
          />
          <mat-error
            *ngIf="enderecoForm.get('telefoneContato')?.hasError('required')"
          >
            Telefone é obrigatório
          </mat-error>
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </section>

  <!-- BOTÕES DE AÇÃO -->
  @if(!this.isGestorOuSaude()) {
  <section class="actions">
    <button mat-button type="button" (click)="cancelar()">Cancelar</button>
    <button matButton="filled" type="submit" (click)="salvarEndereco()">
      Salvar
    </button>
  </section>
  }
</form>
